import { render, staticRenderFns } from "./Stapel.vue?vue&type=template&id=e9f150f8&"
import script from "./Stapel.vue?vue&type=script&lang=js&"
export * from "./Stapel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports